import header from "./default.json";

export function getHeaderPageData() {
  return header;
}
